{
    "StatvaluestypeLabel": "Uitvoer voor velden Percentage, Datum\/Tijd & Duur:",
    "StatvaluestypeBothOptionLabel": "[Dubbele waarden (opgemaakt + onbewerkt)]",
    "StatvaluestypeMainOptionLabel": "Valutaweergave-indeling",
    "StatvaluestypeAlternateOptionLabel": "Help weergeven voor gebruikers die bulksgewijs uploaden.",
    "CSVExportFormat_SectionHeader": "CSV \/ XLS exportformaat",
    "CSVExportFormat_SectionPara": "Je kunt instellen hoe de statistische waarden voor percentages, datum\/tijd en duur worden gegenereerd in CSV- en XLS-rapporten.",
    "NAME": "CSVExportFormat"
}